// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__JJaIL","loaderOuter":"PageOverlayLoader_loaderOuter__3y5YC"};